import { QueueTemplateDto } from "../models/templates";
import { Client } from "../client";
import { Controller } from "..";

export const MessagingQueueTemplatesKey = "messaging-queue-templates";
export const VoiceQueueTemplatesKey = "voice-queue-templates";

export const fetchMesagingQueueTemplates = (
	queueId?: string
): Promise<QueueTemplateDto[]> => {
	return Client.instance.get(Controller.MessagingQueueTemplates, { queueId });
};

export const fetchVoiceQueueTemplates = (
	queueId?: string
): Promise<QueueTemplateDto[]> => {
	return Client.instance.get(Controller.VoiceQueueTemplates, { queueId });
};
